import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const Result = () => {
  const dispatch = useDispatch();
  const pageState = useSelector((state) => state.importSchedulePage);
  const resultApiUrl = pageState.resultApiUrl;
  const resultDatasetId = pageState.resultDatasetId;
  const resultInsertedRows = pageState.resultInsertedRows;
  const resultMessage = pageState.resultMessage;
  const { t } = useTranslation();

  return (
    <div className={`result-page`}>
      {resultMessage}
      <br />
      {resultDatasetId > 0 && (
        <div>
          {t("datasets.create.datasetid")}
          {resultDatasetId} <br />
        </div>
      )}

      <div>
        <br />
        {t("datasets.create.notify")}
        <br />
      </div>
     
      <br />
      <div>
        <b>{t("datasets.create.dataimport1")}</b> {t("datasets.create.dataimport2")}
      </div>
      <ul>
        <li>{t("datasets.create.upload2")}</li>
        <li>{t("datasets.create.connection")}</li>
        <li>
          {t("datasets.create.invoke")}{resultApiUrl}{" "}
          {t("datasets.create.invoke1")}
        </li>
        <li>
          {t("datasets.create.invoke2")}
        </li>
      </ul>
    </div>
  );
};

export default Result;
